import React from 'react';
import { Accordion, AccordionActions, AccordionDetails, AccordionSummary, Alert, AlertTitle, AppBar, Autocomplete, Avatar, AvatarGroup, Backdrop, Badge, BottomNavigation, BottomNavigationAction, Box, Breadcrumbs, Button, ButtonBase, ButtonGroup, Card, CardActionArea, CardActions, CardContent, CardHeader, CardMedia, Checkbox, Chip, CircularProgress, Collapse, Container, CssBaseline, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Drawer, Fab, Fade, FilledInput, FormControl, FormControlLabel, FormGroup, FormHelperText, FormLabel, Grid, Grow, Hidden, Icon, IconButton, ImageList, ImageListItem, ImageListItemBar, Input, InputAdornment, InputBase, InputLabel, LinearProgress, Link, List, ListItem, ListItemAvatar, ListItemButton, ListItemIcon, ListItemSecondaryAction, ListItemText, ListSubheader, Menu, MenuItem, MenuList, MobileStepper, Modal, NativeSelect, OutlinedInput, Pagination, PaginationItem, Paper, Popover, Popper, Portal, Radio, RadioGroup, Rating, ScopedCssBaseline, Select, Skeleton, Slide, Slider, Snackbar, SnackbarContent, SpeedDial, SpeedDialAction, SpeedDialIcon, Stack, Step, StepButton, StepConnector, StepContent, StepIcon, StepLabel, Stepper, SvgIcon, SwipeableDrawer, Switch, Tab, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, TableSortLabel, Tabs, TextField, ToggleButton, ToggleButtonGroup, Toolbar, Tooltip, Typography, Zoom } from '@mui/material';
import { useState, useEffect } from 'react';
import ShowSingleChat from './ShowSingleChat';
import { useAppContext } from 'src/hooks';
import { useLocation } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { _getChatMessages, _addUserInChatList, _seenMessages } from 'src/DAL';
import { del_from_local_storage, get_from_localStorage } from 'src/utils';
import { del_from_sessionStorage, get_from_sessionStorage } from 'src/utils/sessionStorage';


export default function ChatDialog() {
  const { pathname } = useLocation();
  const { enqueueSnackbar } = useSnackbar();
  const {
    currentChat,
    setCurrentChat,
    chatList,
    setChatListDrawerOpen,
    messageCount,
    setMessageList,
    setMessageCount,
    setChatList,
    messageListPageNo,
    setMessageListPageNo,
    isOpenChatDialog,
    setChatCount,
    setIsOpenChatDialog,
    chatType,
    socketEmit,
    isMinimizeChat,
    getModifiedChatItem,
    dispatch_get_user_profile,
    chatData,
    setChatData,
    loadingMessageList,
    setLoadingMessageList,
  } = useAppContext();

  const onChatClick = () => {
  }

  const handleAddNewChat = async (user) => {
    console.log(user, "adding user");
    // setAddChatLoading(true);
    try {
      let temp = chatList.findIndex(
        (chat) => chat.type == "0" && chat.user[0].user_id == user.user_id
      );
      if (temp !== -1) {
        if (currentChat?._id !== chatList[temp]._id) {
          setCurrentChat(chatList[temp]);
          setMessageList([]);
          setMessageListPageNo(0);
          getMessageList(chatList[temp]);
        }
        setChatListDrawerOpen(false);
        return;
      }

      const req_data = {
        team: [
          {
            user_id: user.user_id,
            first_name: user.first_name,
            last_name: user.last_name,
            email: user.email,
            image: user.image,
            status: user.status,
            role: user.role,
            user_status: user.user_status,
          },
          {
            user_id: dispatch_get_user_profile().user_id,
            first_name: dispatch_get_user_profile().first_name,
            last_name: dispatch_get_user_profile().last_name,
            email: dispatch_get_user_profile().email,
            image: dispatch_get_user_profile().image,
            status: dispatch_get_user_profile().status,
            role: "team",
            user_status: dispatch_get_user_profile().user_status,
          },
        ],
      };
      console.log(req_data, "sending data in API when Creating new Chat");
      const result = await _addUserInChatList(req_data);
      if (result.code == 200) {
        console.log(result.chat, "Receiving data from API when Creating new Chat");
        if (chatType == "all") {
          console.log("chatlist updated no: 19");
          setChatList((prev) => {
            return [getModifiedChatItem(result.chat), ...prev];
          });
          setChatCount((prev) => prev + 1);
        }
        setCurrentChat(getModifiedChatItem(result.chat));
        // setIsAddChatDrawerOpen(false);
        enqueueSnackbar("Chat added successfully", { variant: "success" });
        setMessageList([]);
        setMessageListPageNo(0);
        setChatListDrawerOpen(false);
        console.log("Passing Data to Socket while Creating Chat: ", result.chat);
        socketEmit("addNewChat", result.chat);
      } else if (result.code == 400 && result.chat) {
        if (chatType == "all") {
          console.log("chatlist updated no: 20");
          setChatList((prev) => {
            return [getModifiedChatItem(result.chat), ...prev];
          });
        }
        setCurrentChat(getModifiedChatItem(result.chat));
        // setIsAddChatDrawerOpen(false);
        setMessageList([]);
        setMessageListPageNo(0);
        setChatListDrawerOpen(false);
        getMessageList(getModifiedChatItem(result.chat));
      } else {
        enqueueSnackbar(result.message, { variant: "error" });
      }
    } catch (error) {
      enqueueSnackbar("Something went wrong!", { variant: "error" });
      console.log(error, "error catched while adding chat");
    }
  };

  function onLastMassageView() {
    console.log("called 0");
    setCurrentChat({
      ...currentChat,
      unread_count: 0
    });
  }

  const loadMoreMessages = async () => {
    const result = await _getChatMessages(currentChat._id, messageListPageNo);
    if (result.code == 200) {
      setMessageList((prev) => {
        return prev.concat(result.message.message_list);
      });
      setMessageListPageNo((prev) => prev + 1);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  const getMessageList = async (chat) => {
    setLoadingMessageList(true);
    try {
      const result = await _getChatMessages(chat._id);
      if (result.code == 200) {
        setChatData(result.message.chat_data);
        setMessageList(result.message.message_list);
        setMessageCount(result.message.message_count);
        setMessageListPageNo((prev) => prev + 1);

        const res = await _seenMessages(chat._id);
        if (res.code == 200) {
          console.log("Calling seen message socket event");
          let receivers = chat.member_user;
          let receviverIds = receivers?.map((member) => {
            return member.user_id;
          })
          socketEmit("on_message_read", { chat_id: chat._id, receivers_id: receviverIds });
        } else {
          console.log("Failed to call seen message API: ", res.message)
        }
      } else if (
        result.message == "Cannot read properties of null (reading 'type')"
      ) {
        setCurrentChat();
        del_from_sessionStorage("currentChat");
        console.log("chatlist updated no: 21");
        setChatList((prev) =>
          prev.filter((prevChat) => prevChat._id !== chat._id)
        );
      } else {
        enqueueSnackbar(result.message, { variant: "error" });
      }
    } catch (error) {
      enqueueSnackbar("Something went wrong!", { variant: "error" });
      console.log(error, " error catched");
    } finally {
      setLoadingMessageList(false);
    }
  };

  useEffect(() => {
    currentChat && getMessageList(currentChat);
  }, []);

  useEffect(() => {
    return () => {
      setMessageListPageNo(0);
      setMessageList([]);
      setMessageCount(0);
      console.log("chatlist updated no: 22");
      setChatList([]);
      setCurrentChat();
      if (get_from_sessionStorage("currentChat")) {
        del_from_sessionStorage("currentChat");
        del_from_local_storage("chatType");
      }
    };
  }, []);

  return (
    <Dialog
      onClose={() => {
        console.log("why you clicking on side");
      }}
      open={isOpenChatDialog}
      BackdropProps={{ invisible: true }}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        style: {
          position: "fixed",
          bottom: 0,
          right: 2,
          margin: 0,
          pointerEvents: "auto"
        },
        className: `full-chat-dialog ${!isMinimizeChat ? "full-chat-dialog-expanded" : ""}`,
      }}
      sx={{ pointerEvents: "none" }}
      disableEnforceFocus
      disableScrollLock
    >
      <div className={`${!isMinimizeChat && "pt-0"} chat-dialog-content`}>
        {currentChat && <ShowSingleChat
          chatList={chatList}
          onChatClick={onChatClick}
          currentChat={currentChat}
          setCurrentChat={setCurrentChat}
          setChatListDrawerOpen={setChatListDrawerOpen}
          messageCount={messageCount}
          loadMoreMessages={loadMoreMessages}
          isMobile={false}
          onLastMassageView={onLastMassageView}
          handleAddNewChat={handleAddNewChat}
        />}
      </div>
    </Dialog>
  )
}
